var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"id":"students"}},[_c('navbar',{attrs:{"title":"生徒一覧"}}),_c('background',[_c('div',{staticClass:"students"},[_c('student-list')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }